<template>
  <div class="text-fill">
    <relation-input
        ref="input"
      :prefix-icon="prefixIcon"
      :placeholder="placeholder"
      v-model="issue.value"
      :type="inputType"
      :rows="issue.rows"
      @change="$emit('change')"
      :disable-copy="issue.disableCopy"
      :min-length="issue.min_length"
      :max-length="issue.max_length"
      :validate="issue.validate"
      :readonly="issue.readonly"
      :enabled-error-tip="enabledErrorTip"
        :allow-error-list="issue.allowErrorList"
    >
      <template #button v-if="issue.messageValidate">
        <template v-if="!issue.isValidateCode">
          <van-button :disabled="countDown > 0" class="align-bottom" size="mini" type="primary" @click="openDialog">
            <template v-if="countDown > 0">
              <span>{{ countDown }}秒后重试</span>
            </template>
            <template v-else>
              <span>发送验证码</span>
            </template>
          </van-button>
        </template>
        <template v-else>
          <van-button disabled class="align-bottom" size="mini" type="primary">已验证</van-button>
        </template>
      </template>
    </relation-input>
    <!--    <van-field placeholder="请输入" v-model="issue.value" :type="inputType" @change="$emit('change')">-->
    <!--      <template #button v-if="issue.messageValidate">-->
    <!--        <template v-if="!issue.isValidateCode">-->
    <!--          <van-button :disabled="countDown > 0" class="align-bottom" size="mini" type="primary" @click="openDialog">-->
    <!--            <template v-if="countDown > 0">-->
    <!--              <span>{{ countDown }}秒后重试</span>-->
    <!--            </template>-->
    <!--            <template v-else>-->
    <!--              <span>发送验证码</span>-->
    <!--            </template>-->
    <!--          </van-button>-->
    <!--        </template>-->
    <!--        <template v-else>-->
    <!--          <van-button disabled class="align-bottom" size="mini" type="primary">已验证</van-button>-->
    <!--        </template>-->
    <!--      </template>-->
    <!--    </van-field>-->
    <template v-if="issue.messageValidate">
      <template v-if="!issue.isValidateCode">
        <van-field v-if="msgFlag" placeholder="请输入验证码" v-model="msgCode">
          <template #button>
            <van-button class="align-bottom" size="mini" type="primary" @click="onValidate">
              <span>验证</span>
            </van-button>
          </template>
        </van-field>
      </template>
      <template v-else>
        <span>当前手机号已验证，更换手机号</span>
        <span class="text-theme" @click="sendAgain">重新验证</span>
      </template>
    </template>
    <template v-if="questionErrorText">
      <div class="text-danger mt-1">
        <span>{{questionErrorText}}</span>
      </div>
    </template>
    <van-dialog
      v-model="codePopup"
      title="发送验证码"
      :show-cancel-button="true"
      :show-confirm-button="true"
      style="top: 25%"
      @confirm="sendSmsCode"
    >
      <div class="absolute" style="left: 20px; top: 30px">
        <span>
          <van-icon name="cross" @click="codePopup = false" />
        </span>
      </div>
      <div class="mb-5" v-if="codePopup">
        <div class="flex items-center justify-center">
          <img :src="imgCodeUrl" alt="验证码" height="60" />
          <span class="text-theme cursor-pointer ml-5" @click="onRefresh">刷新</span>
        </div>
        <div class="px-5 mt-3">
          <van-field placeholder="请输入图片验证码" v-model="imgCode"></van-field>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import CodeInput from '@/questions/components/CodeInput'
import { getImgCode, sendSmsCode, validateCode, ValidateType } from 'dygc'
import { Notify } from 'vant'
import RelationInput from '../components/RelationInput'

const SUCCESS = 0 // 成功
const REPEAT_SEND = 1 //当前答案已经验证过此手机号
const ERROR = 2 // 失败 短信数量为0或基础模块出错
export default {
  name: 'TextFill',
  components: { RelationInput, CodeInput },
  changeExpr: 'issue.value',
  data() {
    return {
      randomStr: Date.now(),
      codePopup: false,
      countDown: 0,
      msgCode: '',
      imgCode: '',
      msgFlag: false
    }
  },
  computed: {
    enabledErrorTip(){
      if(this.issue.validate !== ValidateType.NUM) return true
      return this.issue.outOfRange !== 1
    },
    questionErrorText(){
      if(!this.question.questionErrorList) return ''
      return this.question.questionErrorList.find(err => err.key === this.question.id)?.message
    },
    imgCodeUrl() {
      return getImgCode(this.issue.value.trim(), this.randomStr)
    },
    inputType() {
      let type = this.issue.inputType
      if (this.issue.validate === 'num') {
        type = 'number'
      }
      if (this.issue.validate === 'phone') {
        type = 'digit'
      }
      return type
    },
    prefixIcon() {
      switch (this.question.issue.validate) {
        case ValidateType.EMAIL:
          return 'p-info-email'
        case ValidateType.NUM:
          return 'p-info-number'
        case ValidateType.CHINESE:
          return 'p-info-chinese'
        case ValidateType.WEBSITE:
          return 'p-info-website'
        case ValidateType.CHAR:
          return 'p-info-word'
        case ValidateType.ID_NUMBER:
          return 'p-info-idcard'
        case ValidateType.PHONE:
          return 'p-info-phone'
        case ValidateType.PASSWORD:
          return 'p-info-password'
      }
      return ''
    },
    placeholder() {
      return this.issue.placeholder || '请输入'
    }
  },
  methods: {
    onRefresh() {
      this.randomStr = Date.now()
    },
    onFinished(val) {
      console.log(val)
      this.imgCode = val
      this.sendSmsCode()
    },
    repeatPhone() {
      // this._message('该手机号在当前答卷已进行验证')
      this.question.issue.isValidateCode = true
      this.oldPhone = ''
    },
    sendSmsCode() {
      if (!this.imgCode) {
        // this._message("请输入图片验证码")
        return
      }
      if (this.__disabled) return
      let answerId = this.$bus.answerId
      let surveyId = this.$bus.survey.id
      let phone = this.issue.value
      let unique = this.issue.data_unique
      let questionId = this.question.id
      if (this.oldPhone === phone) {
        this.repeatPhone()
        this.codePopup = false
        return
      }
      this.__disabled = true
      sendSmsCode({
        answerId,
        surveyId,
        phone,
        unique,
        questionId,
        preCode: this.imgCode.trim()
      })
        .then(res => {
          let data = res.data
          if (data === SUCCESS) {
            this.countDown = 60
            this.openCountDown()
            this.msgFlag = true
            this.codePopup = false
          } else if (data === REPEAT_SEND) {
            this.repeatPhone()
            this.codePopup = false
          } else if (data === ERROR) {
            this.codePopup = false
            if (res.msg === '答题确认短信余额不足') {
              this.issue.messageValidate = false
              return
            } else {
              // this.$refs.codeInput.clear()
              this.$nextTick(() => {
                Notify({
                  message: res.msg,
                  type: 'warning'
                })
              })
            }
            this.imgCode = ''
          } else {
            if (res.msg === '短信发送失败，同一手机号每天最多发送5次') {
              // this.question.issue.messageValidate = false
              this.codePopup = false
            }
            if (res.code === 1) {
              Notify({
                message: res.msg,
                type: 'warning'
              })
              this.codePopup = false
            }
          }
          this.$nextTick(() => {
            this.__disabled = false
          })
        })
        .catch(err => {
          // this.errorTips(err)
        })
    },
    onValidate() {
      // let rootVm = this.rootVm
      let answerId = this.$bus.answerId
      let surveyId = this.$bus.survey.id
      let issue = this.issue
      let code = this.msgCode.trim()
      let phone = issue.value.trim()

      if (!code) {
        Notify({
          message: '请输入验证码',
          type: 'warning'
        })
        return
      }
      if (this.validate) return
      this.validate = true
      validateCode({
        phone,
        answerId,
        surveyId,
        code,
        preCode: this.imgCode.trim()
      })
        .then(res => {
          let { code } = res
          if (code === 0) {
            issue.isValidateCode = true
          } else if (code === 1) {
            Notify({
              message: res.msg,
              type: 'warning'
            })
          } else {
          }
          this.validate = false
        })
        .catch(err => {
          this.validate = false
        })
    },
    openCountDown() {
      this.countDownTimer = setInterval(() => {
        this.countDown--
        if (this.countDown <= 0) {
          this.clearCountDown()
        }
      }, 1000)
    },
    clearCountDown() {
      clearInterval(this.countDownTimer)
      this.countDownTimer = null
      this.countDown = 0
    },
    openDialog() {
      try {
        if (!this.issue.value) {
          throw new Error('手机号不能为空')
        }
        this.issue.check(this.question.required)
        setTimeout(() => {
          this.codePopup = true
          this.imgCode = ''
          this.onRefresh()
        }, 20)
      } catch (e) {
        this.$notify({ message: e.message, type: 'warning' })
      }
    },
    sendAgain() {
      this.$dialog
        .confirm({
          title: '重新验证',
          message: '您确定要重新验证吗？'
        })
        .then(() => {
          let phone = this.issue.value
          this.oldPhone = phone
          this.issue.isValidateCode = false
          this.issue.value = ''
          this.msgFlag = false
          this.msgCode = ''
          this.clearCountDown()
        })
    }
  },
  created() {
    if(this.question.setHook) {
      // fix 有可能是 矩阵题嵌入的组件 question 与正常的不一致
      this.question.setHook('confirm',isOK=>{
        if(isOK) return
        this.$refs.input.$refs.field.focus()
      })
    }
  },
  beforeDestroy() {
    this.clearCountDown()
  }
}
</script>
